import {
  TicketStore,
  TicketsStore,
} from '@/components/editor/TicketPlugin/TicketPlugin';
import React from 'react';

// Tickets store provider component - requires store to be passed in

export function TicketsStoreProvider({
  children,
  store,
}: {
  children: React.ReactNode;
  store: TicketStore;
}) {
  return (
    <TicketsStore.Provider value={store}>{children}</TicketsStore.Provider>
  );
}
